<template>
  <section :class="{'section-checkerboard': item.declination === 'Checkerboard Composition'}">
    <div class="checkerboard" v-if="item.declination === 'Checkerboard Composition'" :class="{ '-bg': item.title || item.text }">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-xl-4" :class="{ 'offset-md-6 offset-xl-7': item.side !== 'right' }">
            <Observer name="fade-up" class="info" v-if="item.title || item.text">
              <h2 class="title" v-if="item.title" v-text="item.title"></h2>
              <p class="text" v-if="item.text" v-html="item.text"></p>
            </Observer>
            <div class="checkerboard-products" v-else-if="item.products">
              <ProductSlider :item="{'itemsToShow': 2}" :items="item.products"></ProductSlider>
            </div>
          </div>
        </div>
      </div>
      <Observer name="fade-up" :class="{ '-left': item.side !== 'right' }">
        <div class="visual" :class="{'-hasBorder': item.hasBorder}">
          <button v-if="item.products && item.products.length > 0 && (item.title || item.text)" type="button" @click="onOpenModal(item)" class="btn-preview font-btn">
            <i class="icon-cart"></i>
            <span>{{ $t('Watch preview') }}</span>
          </button>
          <lazy-picture :item="item" desktop-ratio="1" mobile-ratio="1"></lazy-picture>
        </div>
      </Observer>
    </div>
    <div class="container" v-else>
      <div class="row align-items-center justify-content-center">
        <div class="col-12 col-md-10">
          <Observer name="fade-up">
            <div class="visual" :class="{'-hasBorder': item.hasBorder}">
              <button v-if="item.products && item.products.length > 0" type="button" @click="onOpenModal(item)" class="btn-preview font-btn">
                <i class="icon-cart"></i>
                <span>{{ $t('Watch preview') }}</span>
              </button>
              <lazy-picture :item="item" desktop-ratio="1.38510101" mobile-ratio="1.38510101"></lazy-picture>
            </div>
          </Observer>
        </div>
      </div>
    </div>
    <ModalProduct :is-open="openModalProduct" :data="dataModalProduct" @close="onCloseModal" />
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import LazyPicture from './utils/LazyPicture'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import ProductSlider from './ProductSlider'

export default {
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  name: 'LargeHighlights',
  mixins: [ReadyHook],
  components: {
    LazyPicture,
    ProductSlider,
    ModalProduct: () => import('./ModalProduct')
  },
  data () {
    return {
      openModalProduct: false,
      dataModalProduct: null
    }
  },
  computed: {
    localizedUrl () {
      const { url } = currentStoreView()
      return url || ''
    }
  },
  methods: {
    onOpenModal (data) {
      this.dataModalProduct = data
      this.openModalProduct = true
    },
    onCloseModal () {
      this.openModalProduct = false
      this.dataModalProduct = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  margin: 10rem 0;
  text-align: center;

  @include bp(max md) {
    margin: 4rem 0;
  }

  &.section-checkerboard + .section-checkerboard {
    margin: -10rem 0 10rem;

    @include bp(max md) {
      margin: -4rem 0 4rem;
    }
  }
}

.visual {
  display: inline-block;
  position: relative;

  /deep/ img {
    max-width: 100%;
  }

  &.-hasBorder {
    /deep/ img {
      border: 2rem solid black;
    }
  }
}

.btn-preview {
  position: absolute;
  top: 4rem;
  right: 4rem;
  height: 3.5rem;
  color: var(--zenith-theme-primary);
  border: none;
  margin: 0;
  overflow: hidden;
  padding: 1rem 1rem 1rem 0.8rem;
  border-radius: 3.5rem;
  background-color: var(--zenith-white);
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 3.5rem;
  cursor: pointer;
  transition: max-width 0.3s 0.15s ease-out;

  @include bp(max md) {
    top: 1rem;
    right: 1rem;
  }

  i {
    font-size: 2rem;
  }

  span {
    white-space: nowrap;
    text-transform: uppercase;
    font-size: 1rem;
    line-height: normal;
    margin-left: 1rem;
    opacity: 0;
    transition: opacity 0.3s 0s ease-in;
  }

  &:hover, &:active, &:focus {
    max-width: 20rem;
    transition: max-width 0.3s 0s ease-out;

    span {
      opacity: 1;
      transition: opacity 0.3s 0s ease-out;
    }

  }
}

.checkerboard {
  position: relative;
  overflow: hidden;
  height: 50vw;
  text-align: left;

  &.-bg {
    background-color: #f3f3f3;

    @include bp(max md) {
      padding-bottom: 8rem;
    }
  }

  @include bp(max md) {
    height: auto;
    max-height: none;
    display: flex;
    flex-direction: column-reverse;
  }

  img,
  video {
    position: absolute;
    object-fit: cover;
    height: 100%;
    width: 100%;

    @include bp(max md) {
      position: relative;
      width: 100%;
      height: 100vw;
    }
  }

  & > .obs {
    position: absolute;
    width: 50%;
    top: 0;
    height: 100%;
    transform-style: preserve-3d;

    &.-left {
      left: 0;
    }

    &:not(.-left) {
      right: 0;
    }

    @include bp(max md) {
      position: relative;
      left: auto;
      right: auto;
      top: auto;
      width: 100%;
      height: auto;
      transform: none;
      margin-bottom: 4rem;
    }
  }

  .container-fluid {
    height: 100%;
    .row {
      height: 100%;
      align-items: center;
    }
  }

  .info {
    width: 80%;
    max-width: none;
    margin: auto;

    @include bp(max md) {
      width: 100%;
      max-width: none;
    }

    .subtitle {
      color: var(--zenith-theme-primary-lighter);
    }

    .title {
      margin-top: 2rem;
      color: var(--zenith-theme-primary-lighter);
    }

    .text {
      margin-top: 2rem;
      color: var(--zenith-theme-primary-lighter);
    }

    .btn {
      margin-top: 2rem;
    }
  }

  &-products {

    @include bp(max md) {
      margin: 0 -1.5rem;
    }

    section {
      margin: 0;

      /deep/ .hooper {
        margin: 0;
      }
    }
  }
}
</style>
